import React from 'react';
import { Button } from '@/components/ui/button';

const EmptyState = ({ title, description, actionLabel, onAction }) => (
  <div className="rounded-2xl border border-white/10 bg-white/5 backdrop-blur-md p-10 text-center">
    <p className="text-lg font-medium text-white mb-2">{title}</p>
    {description && <p className="text-sm text-white/60 mb-6 max-w-md mx-auto">{description}</p>}
    {actionLabel && onAction && (
      <Button onClick={onAction} className="bg-[#0E76FF] hover:bg-[#2563EB]">
        {actionLabel}
      </Button>
    )}
  </div>
);

export default EmptyState;
